// @flow

export async function _fetch(url: string) {
  const options = {
    mode: 'cors',
    method: 'GET'
  };

  const response = await fetch(url, options);
  const contentType = response.headers.get('content-type');

  if (!response.ok) {
    throw new Error(response);
  }

  if (response.ok && contentType && contentType.includes('application/json')) {
    return response.json();
  }

  throw new Error('Une erreur est survenue');
}
